import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import Button from '../form/Button';
import OrganizationApi from '../../api/organization';
import ScheduleTable from './ScheduleTable';
import Subnav from '../subnav';

import withEhsPageBehavior from '../../withEhsPageBehavior';

const SchedulePage = props => {
    const id = +props.match.params.organizationId;
    const [state, setState] = useState({
        checkins: [],
        organizationId: id,
        organizationName: '',
        targetDate: null,
        startDate: null,
        totalDays: null,
        elapsedDays: null,
    });

    useEffect(() => {
        async function init() {
            const events = await OrganizationApi.getEvents(
                state.organizationId
            );
            const organization = await OrganizationApi.get(
                state.organizationId
            );

            var startDate = moment(organization.start_date);
            var nowDate = moment();
            var targetDate = moment(organization.end_date);

            setState({
                checkins: events || [],
                organizationId: organization.id,
                organizationName: organization.name,
                targetDate: moment(organization.end_date),
                startDate: moment(organization.start_date),
                totalDays: targetDate.diff(startDate, 'days'),
                elapsedDays:
                    nowDate > startDate ? nowDate.diff(startDate, 'days') : '0',
            });
        }
        init();
    }, []);

    return (
        <main className="page">
            <div className="page__subnav">
                <Subnav organizationId={props.match.params.organizationId} />
            </div>

            <div className="page__header">
                <h2>
                    <i className="fa fa-calendar" /> {state.organizationName}{' '}
                </h2>
            </div>

            <div className="page__body ScheduleContainer">
                {/*<div className="ScheduleContainer__Dates"></div>*/}
                <div className="ScheduleContainer__Events">
                    <ScheduleTable events={state.checkins} />
                </div>
                <div className="Actions">
                    <Link
                        to={
                            '/organization/' +
                            state.organizationId +
                            '/schedule/new'
                        }>
                        <Button defaultText="Add Deadline" icon="fa-plus" />
                    </Link>
                </div>
            </div>
            {/* page__body */}
        </main>
    );
};

export default withEhsPageBehavior(SchedulePage);
